import { useCallback, useRef } from 'react';

export const useDebounceCallback = <T extends unknown[]>(
  cb: (...args: T) => void,
  deps: any[],
  timeout = 50,
) => {
  const timeoutRef = useRef<number>(null);

  return useCallback(
    (...args: T) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        cb(...args);
      }, timeout);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps,
  );
};
